<template>
	<div class="v-container page-menu">
		<div class="v-page-header">平台账号管理</div>
		<div class="v-header">
			<el-button type="primary" size="small" @click="row=null;isShowAddEdit=true"><i class="el-icon-plus"></i> 添加账号</el-button>
			<div>
				<el-input v-model="keyword" class="v-form-item" size="mini" placeholder="真实姓名/账号" style="width: 200px"></el-input>
				<el-button class="v-ml-5" type="primary" size="mini" @click="getList(1)">
					搜索
				</el-button>
				<el-button size="mini" @click="keyword='';getList(1)">重置</el-button>
			</div>
		</div>
		<div v-loading="loading" class="v-content">
			<el-table :data="lists" border size="small" style="width: 100%">
				<el-table-column prop="nickname" label="真实姓名" width="200" />
				<el-table-column prop="loginName" label="登录账号" />
				<el-table-column label="状态" width="80" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 1" class="v-color-green">启用</span> <span v-if="scope.row.status == 2" class="v-color-red">禁用</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120" fixed="right" align="center">
					<template slot-scope="scope">
						<el-button type="default" size="min" icon="el-icon-edit" @click="row=scope.row;isShowAddEdit=true"></el-button>
						<el-popconfirm title="确认删除？" @onConfirm="doDelete(scope.row)">
							<el-button slot="reference" size="min" class="v-ml-5" :loading="scope.row.deleteLoading" icon="el-icon-delete"></el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="v-footer">
			<el-pagination layout="total,sizes,prev, pager, next" :current-page.sync="page" :total="total" @size-change="page_size => {getList(page, page_size)}" @current-change="page => {getList(page);}"></el-pagination>
		</div>
		<addEdit v-if="isShowAddEdit" :show.sync="isShowAddEdit" :row="row" @success="getList" />
	</div>
</template>

<script>
	import addEdit from "./components/add-edit";

	export default {
		components: {
			addEdit
		},

		data() {
			return {
				loading: false,
				isShowAddEdit: false,
				lists: [],
				row: null,
				page: 1,
				pageSize: 10,
				total: 0,
				keyword: "",
			};
		},

		created() {
			this.getList();
		},

		methods: {
			// 获取列表
			async getList(page, pageSize) {
				this.loading = true;
				this.page = page ? page : this.page;
				this.pageSize = pageSize ? pageSize : this.pageSize;
				try {
					let res = await this.api.user.lists({
						page: this.page,
						pageSize: this.pageSize,
						keyword: this.keyword,
					});
					this.lists = res.data.data;
					this.total = res.data.total;
				} catch (e) {
					console.error(e);
				}
				this.loading = false;
			},

			//删除
			async doDelete(row) {
				this.$set(row, 'deleteLoading', true);
				try {
					await this.api.user.delete({id: row.id});
					this.$message.success('删除成功');
					this.getList();
				} catch (e) {
					console.error(e);
				}
				this.$set(row, 'deleteLoading', false);
			},

		}
	};
</script>

<style lang="scss" scoped>
	.v-header {
		display: flex;
		justify-content: space-between;
	}
</style>
